var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAlertSystems = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22V15C2.25 9.62 6.62 5.25 12 5.25C17.38 5.25 21.75 9.62 21.75 15V22C21.75 22.41 21.41 22.75 21 22.75ZM3.75 21.25H20.25V15C20.25 10.45 16.55 6.75 12 6.75C7.45 6.75 3.75 10.45 3.75 15V21.25Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.75C11.59 3.75 11.25 3.41 11.25 3V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V3C12.75 3.41 12.41 3.75 12 3.75Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99994 5.74994C4.80994 5.74994 4.61994 5.67994 4.46994 5.52994L3.46994 4.52994C3.17994 4.23994 3.17994 3.75994 3.46994 3.46994C3.75994 3.17994 4.23994 3.17994 4.52994 3.46994L5.52994 4.46994C5.81994 4.75994 5.81994 5.23994 5.52994 5.52994C5.37994 5.67994 5.18994 5.74994 4.99994 5.74994Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 5.74994C18.8099 5.74994 18.6199 5.67994 18.4699 5.52994C18.1799 5.23994 18.1799 4.75994 18.4699 4.46994L19.4699 3.46994C19.7599 3.17994 20.2399 3.17994 20.5299 3.46994C20.8199 3.75994 20.8199 4.23994 20.5299 4.52994L19.5299 5.52994C19.3799 5.67994 19.1899 5.74994 18.9999 5.74994Z",
    fill: "#292D32"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertSystems, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alertSystems.f60cc9c9.svg";
export { ForwardRef as ReactComponent };